import React, { useEffect, useRef, useState } from "react"
import { defPath } from "../../config/defPath";

import * as yup from 'yup';

import { resendCodeV2, resetUserV2, sendCodeV2, updateDataV2 } from "../../components/layout/sendForm";
import { PreferencesPopup } from "./preferencesPopup";
import { CountdownTimer } from "./countdownTimer";

import { useLocation } from "wouter";
import { useRecoveryForms } from "./useRecoveryForms";
import { useRecovery } from ".";
import { useDatalayer } from "../../hooks/useDatalayer";


const emails = ['temp-mail.org', 'correotemporal.org', 'mohmal.com', 'yopmail.com', 'tempail.com', 'emailondeck.com', 'emailtemporalgratis.com', 'crazymailing.com', 'tempr.email', 'bupmail.com', 'guerrillamail.com', 'temp-mail.io', 'es.emailfake.com', 'nowmymail.com', '10minutemail.net', 'es.getairmail.com', 'mailf5.com', 'flashmail.it', '10minemail.com', 'mailcatch.com', 'temp-mails.com', 'spambox.us', 'mailnull.com', 'incognitomail.com', 'ssl.trashmail.net', 'trashmail.net', 'mailinator.com', 'tempinbox.com', 'filzmail.com', 'dropmail.me', 'spam4.me', 'cs.email', 'one-off.email', 'throwawaymail.com', 'emailtemporal.org', 'maildrop.cc', 'mailforspam.com', 'trashmail.com', 'teleworm.us', 'superrito.com', 'rhyta.com', 'jourrapide.com', 'gustr.com', 'fleckens.hu', 'einrot.com', 'cuvox.de', 'dayrep.com', 'muyoc.com', 'buxod.com', 'pidox.org', 'mecip.net', 'pudxe.com', 'xedmi.com', 'ludxc.com', 'juzab.com', 'klepf.com', 'matra.site', 'bombamail.icu', 'yermail.net', 'totallynotfake.net', 'techblast.ch', 'spamthis.network', 'spammy.host', 'spammer.fail', 'shadap.org', 'pewpewpewpew.pw', 'netcom.ws', 'itcompu.com', 'disposable.site', 'deinbox.com', 'sharklasers.com', 'guerrillamailblock.com', 'guerrillamail.org', 'guerrillamail.net', 'guerrillamail.de', 'guerrillamail.biz', 'grr.la', 'netmail.tk', 'laste.ml', 'firste.ml', 'zeroe.ml', 'supere.ml', 'emlhub.com', 'emlpro.com', 'emltmp.com', 'yomail.info', '10mail.org', 'wegwerfmail.org', 'wegwerfmail.net', 'wegwerfmail.de', 'trashmail.me', 'trashmail.io', 'trashmail.at', 'trash-mail.at', 'rcpt.at', 'proxymail.eu', 'objectmail.com', 'kurzepost.de', 'damnthespam.com', 'contbay.com', '0box.eu', 'marmaryta.space', '5y5u.com', '58as.com', 'firemailbox.club', 'mozej.com', 'mailna.co', 'mailna.in', 'mailna.me', 'mohmal.im', 'mohmal.in', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr', 'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'nedoz.com', 'nmagazinec.com', 'armyspy.com', 'vmani.com', 'discard.email', 'discardmail.com', 'discardmail.de', 'spambog.com', 'spambog.de', 'spambog.ru', '0btcmail.pw', '815.ru', 'knol-power.nl', 'hartbot.de', 'freundin.ru', 'smashmail.de', 's0ny.net', 'pecinan.net', 'budaya-tionghoa.com', 'lajoska.pe.hu', '1mail.x24hr.com', 'from.onmypc.info', 'now.mefound.com', 'mowgli.jungleheart.com', 'yourspamgoesto.space', 'pecinan.org', 'budayationghoa.com', 'CR.cloudns.asia', 'TLS.cloudns.asia', 'MSFT.cloudns.asia', 'B.cr.cloUdnS.asia', 'ssl.tls.cloudns.ASIA', 'sweetxxx.de', 'DVD.dns-cloud.net', 'DVD.dnsabr.com', 'BD.dns-cloud.net', 'YX.dns-cloud.net', 'SHIT.dns-cloud.net', 'SHIT.dnsabr.com', 'eu.dns-cloud.net', 'eu.dnsabr.com', 'asia.dnsabr.com', '8.dnsabr.com', 'pw.8.dnsabr.com', 'mm.8.dnsabr.com', '23.8.dnsabr.com', 'pecinan.com', 'disposable-email.ml', 'pw.epac.to', 'postheo.de', 'sexy.camdvr.org', 'Disposable.ml', '888.dnS-clouD.NET', 'adult-work.info', 'casinokun.hu', 'bangsat.in', 'wallus.casinokun.hu', 'trap-mail.de', 'umailz.com', 'panchoalts.com', 'gmaile.design', 'ersatzauto.ch', 'tempes.gq', 'cpmail.life', 'tempemail.info', 'coolmailcool.com', 'kittenemail.com', '99email.xyz', 'notmyemail.tech', 'm.cloudns.cl', 'twitter-sign-in.cf', 'anonymized.org', 'you.has.dating', 'ketoblazepro.com', 'kost.party', '0hio0ak.com', '4dentalsolutions.com', 't.woeishyang.com', 'ondemandemail.top', 'kittenemail.xyz', 'blackturtle.xyz', 'y.x.ssl.cloudns.asia', 'geneseeit.com', 'mailg.ml', 'media.motornation.buzz', 'sage.speedfocus.biz', 'badlion.co.uk', 'safeemail.xyz', 'virtual-generations.com', 'new-york.host', 'mrdeeps.ml', 'kitela.work', 'fouadps.cf', 'megacorp.work', 'fake-wegwerf.email', 'tigytech.com', 'historictheology.com', 'ma.567map.xyz', 'hotmailproduct.com', 'maxsize.online', 'happyfreshdrink.com', 'denomla.com', 'pansamantala.poistaa.com', 'sahaltastari.sytes.net', 'cecep.ddnsking.com', 'fadilmalik.ddnsking.com', 'csingi.sytes.net', 'richmail.ga', 'tikmail.gq', 'bupkiss.ml', 'guerrillamail.info', 'pokemail.net', 'myinbox.icu', 'just4fun.me', 'inscriptio.in', 'cloud-mail.top', 'safemail.icu', 'montokop.pw', 'tempamailbox.info', 'blogtron.com', 'atanetorg.org', 'aristockphoto.com', 'jomcs.com', 'kukuka.org', 'gothill.com', 'mixely.com', 'marsoasis.org', 'walmarteshop.com', 'outlandlabs.com', 'comectrix.com', 'buymondo.com', 'eventao.com', 'louieliu.com', 'mymailnow.xyz', 'cuoly.com', 'getnada.com', 'abyssmail.com', 'boximail.com', 'clrmail.com', 'dropjar.com', 'getairmail.com', 'givmail.com', 'inboxbear.com', 'robot-mail.com', 'tafmail.com', 'vomoto.com', 'zetmail.com'];

export const SendCodeForm = ({ data, onValid }: { data: any, onValid?: (p?: any) => void }) => {
    const { pushDatalayer } = useDatalayer('Votaciones');
    const isMounted = useRef(true);

    const recoverySchema = yup.object().shape({
        emailOrPhone: yup
            .string()
            .required('Este campo e obligatorio')
            .test(
                'is-valid-field',
                'Ingresa un email o teléfono válido',
                (value) => {
                    return /^(\d{7,10})$|(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,})$/.test(value);
                })
            .test(
                'no-mailinator',
                'Ingrese un email válido',
                (value) => {
                    if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/.test(value)) {
                        let array_email = value.split("@");
                        return !emails.find(m => m === array_email[1]);
                    }
                    return true;
                }
            ),
    })

    const {
        isLoading,
        values: { emailOrPhone },
        handleChange,
        onSubmit,
        setErrors,
        errors
    } = useRecoveryForms({ schema: recoverySchema, fields: { emailOrPhone: '' } });
    const { setRecoverySession, recoverySession } = useRecovery();

    const sendForm = async () => {
        try {
            const response = await resetUserV2(emailOrPhone);
            if (isMounted.current) {
                setRecoverySession({ ...recoverySession, emailOrPhone, value: response.data.value });
                onValid?.();
            }
        } catch (err) {
            if (isMounted.current) {
                setErrors((prevState) => ({ ...prevState, emailOrPhone: err.message }));
                console.error(err);
            }
        }
    }

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    return (
        <div>
            <h1 className="ar__login_v2__title">{data.title}</h1>
            <p className="ar__login_v2__desc">{data.description}</p>
            <form id="recovery" className="ar__form_v2">
                <fieldset className="js-form-item">
                    <div className="js-form-input">
                        <img src={`${defPath}/assets/images/icons/icon_strs_phone.svg`} alt="" title="" loading="lazy" width="18" height="18" />
                        <input className={errors.emailOrPhone ? "error": ""} disabled={isLoading} value={emailOrPhone} onChange={handleChange} id="emailOrPhone" name="emailOrPhone" type="text" placeholder="CORREO/CELULAR" maxLength={50} required autoComplete="off" />
                    </div>
                    {errors.emailOrPhone && <p className="error-message">{errors.emailOrPhone}</p>}
                </fieldset>
                {
                    data.btn
                    && (
                        <button onClick={() => {
                            pushDatalayer({
                                'event_action': 'Button',
                                'event_label': 'Send code',
                                'component_name': 'MOTM_Forget_User',
                                'element_text': 'Cerrar modal',
                            })
                            onSubmit(sendForm)
                        }} className="ar__login_v2__submit" type="button" disabled={isLoading}>
                            {isLoading ? <div className="spinner"></div> : data.btn}
                        </button>
                    )
                }
            </form>
        </div>
    )
}

export const ValidateCodeForm = ({ data, onValid, onBack }: { data: any, onValid?: (p?: any) => void, onBack?: () => void }) => {
    const { pushDatalayer } = useDatalayer('Votaciones');
    const isMounted = useRef(true);
    const [enableResend, setEnableResend] = useState(false);

    const codeSchema = yup.object().shape({
        code: yup
            .string()
            .required('El código es obligatorio')
    })

    const {
        isLoading,
        values: { code },
        handleChange,
        onSubmit,
        setErrors,
        errors
    } = useRecoveryForms({ schema: codeSchema, fields: { code: '' } });
    const { recoverySession, setRecoverySession } = useRecovery();

    const sendForm = async () => {
        try {
            const response = await sendCodeV2({ reset: recoverySession.emailOrPhone, code });
            if (isMounted.current) {
                setErrors((prevState) => ({ ...prevState, code: '' }));
                setRecoverySession({ ...recoverySession, token: response.data.token });
                onValid?.(response.data.token);
            }
        } catch (err) {
            if (isMounted.current) {
                setErrors((prevState) => ({ ...prevState, code: err.message }));
                console.error(err);
            }
        }
    }

    const resendCode = async () => {
        try {
            await resendCodeV2({ reset: `${recoverySession.emailOrPhone}`, value: recoverySession.value })
            setEnableResend(false);
        } catch (err) {
            setErrors((prevState) => ({ ...prevState, code: err.message }));
            console.error(err);
        }
    }

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (errors?.code) {
            pushDatalayer({
                'event_action': 'Button',
                'event_label': 'Error in Code',
                'component_name': 'MOTM_Forget_User',
                'element_text': 'Error en código',
            })
        }
    }, [errors]);

    return (
        <div>
            <p className="ar__login_v2__back" onClick={onBack}>VOLVER</p>
            <h1 className="ar__login_v2__title">{data.title}</h1>
            <p className="ar__login_v2__desc">{data.description}</p>
            <form id="recovery" className="ar__form_v2">
                <fieldset className="js-form-item">
                    <div className="js-form-input">
                        <img src={`${defPath}/assets/images/icons/icon_strs_sms.svg`} alt="" title="" loading="lazy" width="18" height="18" />
                        <input className={errors.code ? "error": ""} disabled={isLoading} value={code} onChange={handleChange} id="code" name="code" type="text" placeholder="CÓDIGO" maxLength={10} required />
                    </div>
                    {errors.code && <p className="error-message">{errors.code}</p>}
                </fieldset>
                {
                    data.btn
                    && (
                        <button onClick={() => {
                            pushDatalayer({
                                'event_action': 'Button',
                                'event_label': 'Log On',
                                'component_name': 'MOTM_Forget_User',
                                'element_text': 'Ingresar',
                            })
                            onSubmit(sendForm)
                        }} className="ar__login_v2__submit" type="button" disabled={isLoading}>
                            {isLoading ? <div className="spinner"></div> : data.btn}
                        </button>
                    )
                }
                {
                    enableResend
                        ? <a className="ar__login_v2__link" onClick={resendCode}>{data.btn2}</a>
                        : (
                            <div className="ar__login_v2__timer">
                                <p>{data.copy}: <CountdownTimer initialTime={60} onEnded={() => setEnableResend(true)} /></p>
                            </div>
                        )
                }

            </form>
        </div>
    )
}

export const UpdateFormForm = ({ data, onValid }: { data: any, onValid?: (p?: any) => void }) => {
    const { pushDatalayer } = useDatalayer('Votaciones');
    const isMounted = useRef(true), popupRef = useRef(null);
    const [, navigate] = useLocation();

    const updateSchema = yup.object().shape({
        emailOrPhone: yup
            .string()
            .required('Este campo e obligatorio')
            .test(
                'is-valid-field',
                'Ingresa un email o teléfono válido',
                (value) => {
                    return /^(\d{7,10})$|(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,})$/.test(value);
                })
            .test(
                'no-mailinator',
                'Ingrese un email válido',
                (value) => {
                    if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/.test(value)) {
                        let array_email = value.split("@");
                        return !emails.find(m => m === array_email[1]);
                    }
                    return true;
                }
            ),
    })

    const {
        isLoading,
        values: { emailOrPhone, marketing, tyc, privacity },
        handleCheck,
        handleChange,
        onSubmit,
        setErrors,
        errors
    } = useRecoveryForms({ schema: updateSchema, fields: { emailOrPhone: '', marketing: 0, tyc: 0, privacity: 0 } });
    const { recoverySession } = useRecovery();

    const sendForm = async () => {
        const preferences = { ...popupRef.current?.preferencesValues };
        if (!marketing) for (const key in preferences) preferences[key] = 0;
        try {
            const messages = { tyc: '', privacity: '' };
            if (tyc === 0) messages.tyc = 'Debes aceptar términos y condiciones';
            if (privacity === 0) messages.privacity = 'Debes aceptar políticas de privacidad';

            setErrors((prevState) => ({ ...prevState, ...messages }));
            if (!Object.values(messages).every(item => item === '')) return;

            await updateDataV2({ reset: `${emailOrPhone}`, token: recoverySession.token, str: `${recoverySession.emailOrPhone}`, tyc, privacity, marketing, ...preferences });
            if (isMounted.current) {
                onValid?.();
                navigate('/estadio-aguila/iniciar-sesion');
            }
        } catch (err) {
            if (isMounted.current) {
                setErrors((prevState) => ({ ...prevState, emailOrPhone: err.message }));
                console.error(err);
            }
        }
    }

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    return (
        <>
            <div>
                <h1 className="ar__login_v2__title">{data.title}</h1>
                <p className="ar__login_v2__desc">{data.description}</p>
                <form id="recovery" className="ar__form_v2">
                    <fieldset className="js-form-item">
                        <div className="js-form-input">
                            <img src={`${defPath}/assets/images/icons/icon_strs_phone.svg`} alt="" title="" loading="lazy" width="18" height="18" />
                            <input className={errors.emailOrPhone ? "error": ""} disabled={isLoading} value={emailOrPhone} onChange={handleChange} id="emailOrPhone" name="emailOrPhone" type="text" placeholder="CORREO/CELULAR" maxLength={50} required autoComplete="off" />
                        </div>
                        {errors.emailOrPhone && <p className="error-message">{errors.emailOrPhone}</p>}
                    </fieldset>
                    <fieldset className="js-form-item js-form-type-checkbox">
                        <input disabled={isLoading} id="tyc" name="tyc" type="checkbox" required checked={!!tyc} onChange={handleCheck} />
                        <div>
                            <label htmlFor="tyc" dangerouslySetInnerHTML={{ __html: data.tyc?.value || '' }}></label>
                            {errors.tyc && <p className="error-message">{errors.tyc}</p>}
                        </div>
                    </fieldset>
                    <fieldset className="js-form-item js-form-type-checkbox">
                        <input disabled={isLoading} id="privacity" name="privacity" type="checkbox" required checked={!!privacity} onChange={handleCheck} />
                        <div>
                            <label htmlFor="privacity" dangerouslySetInnerHTML={{ __html: data.privacity?.value || '' }}></label>
                            {errors.privacity && <p className="error-message">{errors.privacity}</p>}
                        </div>
                    </fieldset>
                    <fieldset className="js-form-item js-form-type-checkbox">
                        <input disabled={isLoading} id="marketing" name="marketing" type="checkbox" checked={!!marketing} onChange={handleCheck} />
                        <div>
                            <label htmlFor="marketing" dangerouslySetInnerHTML={{ __html: data.marketing?.value || '' }}></label>
                        </div>
                    </fieldset>
                    {
                        data.btn
                        && (
                            <button onClick={() => {
                                pushDatalayer({
                                    'event_action': 'Button',
                                    'event_label': 'Actualizar',
                                    'component_name': 'MOTM_Update',
                                    'element_text': 'Actualizar',
                                })
                                onSubmit(sendForm)
                            }} className="ar__login_v2__submit" type="button" disabled={isLoading}>
                                {isLoading ? <div className="spinner"></div> : data.btn}
                            </button>
                        )
                    }
                </form>
            </div>
            <PreferencesPopup ref={popupRef} data={data.popup} />
        </>
    )
}